import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import "./GlobalPopUp.scss";

const GlobalPopUp = ({ text }) => {
  const { getHtmlByKey } = useContent();

  return (
    <div className="popup-global-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div className="text">{getHtmlByKey(text)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalPopUp;
